import updateNotes from '@services/cart/updateNotes';
import { UPDATE_CART_NOTES } from '@core/reducers/cart/actionTypes';
import updateCartProp from './updateCartProp';

const errorMessage =
  'Ocurrió un error al actualizar las notas. Por favor intente nuevamente.';

const updateCartNotes = notes => async (dispatch, _, axios) =>
  dispatch(
    updateCartProp({
      updateProp: cartId =>
        updateNotes({
          axios,
          notes,
          cartId,
        }),
      actionType: UPDATE_CART_NOTES,
      errorMessage,
    }),
  );

export default updateCartNotes;
